import { Controller } from "@hotwired/stimulus"

// Task picker: manages debounced submit only.
// Loading state is handled by CSS via turbo-frame[aria-busy].
export default class extends Controller {
  static targets = ["form", "searchInput"]
  static values  = { emailId: Number }

  connect() {
    this._debounceTimer = null
  }

  debouncedSubmit() {
    clearTimeout(this._debounceTimer)
    this._debounceTimer = setTimeout(() => this.submit(), 300)
  }

  submit() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
